import {useState, useEffect, useRef} from 'react';
import {Outlet, Link, useLocation, matchRoutes, useNavigate} from 'react-router-dom'
import {Fragment} from 'react'
import { matchSorter } from 'match-sorter';

import './searchbar.styles.css'

import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';

import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
 import InputAdornment from '@mui/material/InputAdornment';
import Autocomplete from '@mui/material/Autocomplete';


import { useTranslation } from "react-i18next";
import "../../translations/i18n";



const Search = ({types, onGlobalSearchChange, globalSearchString, globalSearchType, apiUrl, lang}) => {

  const refSearch = useRef();
  const refType = useRef();

  const [searchString, setSearchString] = useState('');
  const [searchStringValue, setSearchStringValue] = useState('');
  const [searchType, setSearchType] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  const [resources, setResources] = useState([]);
  const [resourcesTitles, setResourcesTitles] = useState([]);

  const {t} = useTranslation();

  const searchRoutes = [{path: "/search/"}];
  const landingRoutes = [{path: "/"}];

  const [isLanding, setIsLanding] = useState(false);
  
  const { REACT_APP_MY_LANG, REACT_APP_MY_URL, REACT_APP_MY_API_URL } = process.env;

  useEffect(
    ()=> {
      const url=REACT_APP_MY_API_URL+'/ShortResources/'
      fetch(url)
      .then(response=> response.json())
      .then((resources) => {
        const resTit = resources.map(x => (x.Abbreviation?x.Abbreviation+": ":'')+ x.Name);
        // console.log(resTit);
        setResourcesTitles(resTit)
        setResources(resources);
      });
     }
    ,[]);

  useEffect( ()=> {
    //console.log("force clean search", refSearch.current)
    if (refSearch.current && ! globalSearchString ) {
      //console.log(refSearch.current.children[0].children)
      //refSearch.getElementsByClassName('MuiAutocomplete-clearIndicator')[0].click();
      //this.refs[autocomp].getElementsByClassName('MuiAutocomplete-clearIndicator')[0].click();
      //refSearch.current.value = '';
    }
    setSearchString('');
  },
  [globalSearchString])

  useEffect( ()=> {
    if (refType.current && ! globalSearchType )
      refType.current.value = '';
    setSearchType(null);
  },
  [globalSearchType])

  useEffect( () => {
    setIsLanding(matchRoutes(landingRoutes, location)!==null)
  }, [location])

  const handleSearch = e => {
   // console.log(searchString)
    //jesli nie jestesmy w wynikach wyszukiwania to przejdzmy do nich
    if (isLanding)
      onGlobalSearchChange(searchString, searchType)
    else
      onGlobalSearchChange(searchString, null)
    if (! matchRoutes(searchRoutes, location)) {
      navigate('/search/', {replace: true}, [navigate]);
    }
  }


  const onChangeSearchType = e => {
    // console.log(e.target.value)
    if (e.target.value)
      setSearchType(e.target.value);
    else {
      refType.current.value = '';
    }
  }

  const onChangeSearchString = e => {
    if (e.target.value)
    {
      // console.log(e.target.value);
      setSearchString(new String(e.target.value));
    }
    else {
      refSearch.current.value = '';
      // console.log(this.refs[refSearch])
      // this.refs[refSearch].getElementsByClassName('MuiAutocomplete-clearIndicator')[0].click();
    }
  }

  const filterOptions = (resTit,  { inputValue }) => {
    const ret = matchSorter(resources, inputValue, {keys: [
      {threshold: matchSorter.rankings.CONTAINS, key: 'Name'},
      {threshold: matchSorter.rankings.CONTAINS, key: 'Abbreviation'},
      {threshold: matchSorter.rankings.CONTAINS,key: 'Description'}
    ]})
    //console.log('ret', ret)
    const indexes = resources.map((e,i)=>[e,i]).filter(([e,i]) => ret.includes(e)).map(([e,i])=>i);
    //console.log('indexes',indexes)
    const newTitles = resourcesTitles.map((e,i)=>[e,i]).filter(([e,i]) => indexes.includes(i)).map(([e,i])=>e);
    //console.log('newTit', newTitles);
    return newTitles;
  
}

   return (
     <Fragment>
        <div className="search-bar">
          <div className="search-bar-wrapper">
          <Box className="search-bar-box"  
          // sx={{ minWidth: 800}}
          >
          <FormControl sx={{ m: 1, padding:0 }} size="small">
          <Stack 
          className="search-bar-stack"
          spacing={1}
          direction="row"
          //sx={{ minWidth: 800}}
          divider={<Divider className="search-divider" orientation="vertical" flexItem />}
          >
              {   isLanding &&
              <>
              
                    <InputLabel 
                      className="search-bar-dropdown-label" 
                      id="demo-simple-select-helper-label">
                        {t('search.search_in_resources')}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-helper-label"
                      variant="standard" 
                      ref={refSearch}
                      id="demo-simple-select"
                      label={t('search.search_in_resources')}
                      onChange={onChangeSearchType}
                      //defaultValue=''
                      // displayEmpty
                      className="search-bar-dropdown"
                      // sx={{minWidth: 200}}

                        disableUnderline

                    >
                    <MenuItem value=''><em>{t('search.all')}</em></MenuItem>
                      { types.map( (item, index) => {
                         return (
                         <MenuItem key={index} value={parseInt(item.Id)}>{item.Name}</MenuItem>
                         );
                       })}
                    </Select>
              
                  </>
              }
                  {/* <TextField 
                    variant="standard" 
                    sx={{minWidth:500, width:'100%', flexGrow: 1, paddingLeft: '1rem'}} 
                    inputRef={refSearch} 
                    aaalabel="Pole wyszkiwania" 
                    type="search"
                    onChange={onChangeSearchString} 
                    onKeyPress={
                      (e) => {
                        if (e.key === 'Enter') {
                          handleSearch();
                          e.preventDefault();
                      }
                    }
                  }
                  
                  InputProps={{
                    disableUnderline: true,
                    endAdornment: (
                      // <InputAdornment>
                        <IconButton onClick={handleSearch}>
                          <SearchIcon />
                        </IconButton>
                      // </InputAdornment>
                    )
                  }}
                  /> */}
                  <Autocomplete 
                  freeSolo
                  ref={refSearch}
                  inputValue={searchStringValue}
                  value={searchString}
                  //onChange={onChangeSearchString} 
                  onInputChange={(_,v)=>setSearchStringValue(v)}
                  onChange={(_,v)=>{
                    if (resourcesTitles.includes(v)) {
                      const index = resourcesTitles.indexOf(v);

                      //jesli sa w tytule : to daj ostatni element, juz nie
                      const realName = resources[index].Name; //.split(":").slice(-1)[0];
                      setSearchString(realName)
                      //console.log(realName);
                      if (isLanding)
                        onGlobalSearchChange(realName, searchType)
                    else
                       onGlobalSearchChange(realName, null)
                    if (! matchRoutes(searchRoutes, location)) {
                      navigate('/search/', {replace: true}, [navigate]);
                    }
                    }
                    else
                      setSearchString(v)}
                  }
                  onKeyPress={
                        (e) => {
                          if (e.key === 'Enter') {
                            handleSearch();
                            e.preventDefault();
                        }
                      }
                    }
                  // sx={{minWidth:500, width:'100%', flexGrow: 1}}
                  className="search-bar-autocomplete"
                    options={resourcesTitles}
                    filterOptions={filterOptions}
                    renderInput={(params) => (
                      <TextField
                      inputRef={refSearch} 
                      className="search-bar-input-text"
                      // sx={{minWidth:500, width:'100%', flexGrow: 1}}
                      {...params}
                      
                      type="search" 
                      variant="standard" 
                      
                    InputProps={{
                      ...params.InputProps,
                      disableUnderline: true,
                      startAdornment: (
                        // <InputAdornment>
                          <IconButton onClick={handleSearch}>
                            <SearchIcon />
                          </IconButton>
                        // </InputAdornment>
                      )

                    }}
                      />
                    )}
                  />

            </Stack>
            </FormControl>
            </Box>
            </div>
       </div>
       <div className="content-wrapper">
       <Outlet />
       </div>
     </Fragment>
   )
 }


export default Search;